import * as React from 'react'
import {Tabs as TabsPrimitive} from 'radix-ui'

import {cn} from '@/lib/utils'

const Tabs = TabsPrimitive.Root

function TabsList({className, ...props}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn('flex items-center gap-1 border-b border-border', className)}
      {...props}
    />
  )
}

function TabsTrigger({className, ...props}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        'relative cursor-pointer rounded-t-md px-3 py-2.5 font-mono text-[11px] font-semibold tracking-wider text-muted-foreground uppercase transition-colors outline-none',
        'hover:bg-muted/60 hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring/50',
        'data-[state=active]:text-foreground',
        "after:absolute after:inset-x-0 after:-bottom-px after:h-[2px] after:rounded-full after:bg-primary after:opacity-0 after:content-['']",
        'data-[state=active]:after:opacity-100',
        className
      )}
      {...props}
    />
  )
}

function TabsContent({className, ...props}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content data-slot="tabs-content" className={cn('outline-none', className)} {...props} />
}

export {Tabs, TabsList, TabsTrigger, TabsContent}
